import PageHero from "../components/sections/PageHero";

const sections = [
  {
    h: "Website Use",
    p: "This website is provided for general information purposes only. Visitors are expected to use the website lawfully and in good faith.",
  },
  {
    h: "No Legal Advice",
    p: "The content on this website does not constitute legal advice. Specific legal matters require professional consultation based on the relevant facts and circumstances.",
  },
  {
    h: "No Lawyer-Client Relationship",
    p: "Browsing this website, viewing its content or submitting an enquiry through any form does not, by itself, create a lawyer-client relationship with Lex Polaris, Advocates & Solicitors.",
  },
  {
    h: "No Solicitation",
    p: "In compliance with the rules of the Bar Council of India, Lex Polaris does not solicit work or advertise through this website. The information available is not intended as advertisement.",
  },
  {
    h: "Intellectual Property",
    p: "All content, design elements, text and structure on this website are the property of Lex Polaris or its licensors and may not be reproduced, distributed or used without written permission.",
  },
  {
    h: "Limitation of Liability",
    p: "Lex Polaris is not liable for any decisions, actions or losses arising from reliance on information available through this website. Visitors should seek professional legal advice for specific matters.",
  },
  {
    h: "External Links",
    p: "The website may contain references or links to external sources. Lex Polaris is not responsible for the content, accuracy or practices of any third-party websites.",
  },
  {
    h: "Governing Law",
    p: "Use of this website is governed by the applicable laws of India. Any dispute arising in connection with this website shall be subject to the exclusive jurisdiction of the courts at Gurugram.",
  },
];

export default function TermsPage() {
  return (
    <>
      <PageHero
        eyebrow="Legal"
        title="Terms of Use"
        subtitle="The terms governing your use of this website."
        breadcrumbs={[{ label: "Home", to: "/" }, { label: "Terms of Use" }]}
      />
      <section className="bg-ivory section-y" data-testid="terms-content">
        <div className="container-px max-w-3xl mx-auto">
          {sections.map((s, i) => (
            <div key={s.h} className="mb-10 md:mb-12" data-testid={`terms-section-${i}`}>
              <h2 className="font-serif text-2xl md:text-3xl text-navy mb-4">{s.h}</h2>
              <p className="body-lg text-charcoal/80">{s.p}</p>
            </div>
          ))}
          <p className="text-xs tracking-[0.22em] uppercase text-charcoal/55 mt-12 pt-8 border-t border-soft-grey">
            Last updated: {new Date().toLocaleDateString("en-IN", { year: "numeric", month: "long" })}
          </p>
        </div>
      </section>
    </>
  );
}
